<template>
  <!-- Hide app navigation for certain pages. -->
  <footer v-if="onboarding === undefined || forbidden === undefined || plan || admin"></footer>
  <footer v-else-if="!(onboarding || forbidden || plan)" class="fixed inset-x-0 bottom-0 max-w-screen-sm w-full left-1/2 -translate-x-1/2">
    <nav class="flex flex-row items-center justify-around p-4 bg-white">
      <div @click="goToHome()">
        <img src="@/assets/home.png" class="h-10" :class="{ 'opacity-50' : $route.path !== '/' }">
      </div>
      <div @click="openDataSelector()">
        <img src="@/assets/data.png" class="h-10" :class="{ 'opacity-50' : !data }">
      </div>
      <div @click="goToProfile()" class="relative inline-flex" :class="{ 'opacity-50': $route.path !== '/profile' }">
        <img src="@/assets/profile.png" class="h-10">
        <span v-if="!account" class="absolute top-0.5 right-0.5 grid min-h-[12px] min-w-[12px] translate-x-2/4 -translate-y-2/4 place-items-center rounded-full bg-red-500 py-1 px-1 text-xs font-medium leading-none text-white content-['']"></span>
      </div>
    </nav>
  </footer>

  <!-- Data selector -->
  <v-dialog
    v-model="dataSelector"
    width="auto"
  >
    <v-card
      min-width="300"
    >
      <div class="text-xs tracking-widest m-8">SELECT KEY METRIC</div>
      <div class="flex flex-row justify-around p-4">
        <div @click="goToData('consistency')" class="flex flex-col align-center w-16">
          <img src="@/assets/metric_consistency.png" class="h-10">
          <span class="text-xs">Consistency</span>
        </div>
        <div @click="goToData('duration')" class="flex flex-col align-center w-16">
          <img src="@/assets/metric_duration.png" class="h-10">
          <span class="text-xs">Duration</span>
        </div>
        <div @click="goToData('quality')" class="flex flex-col align-center w-16">
          <img src="@/assets/metric_quality.png" class="h-10">
          <span class="text-xs">Quality</span>
        </div>
      </div>
  </v-card>
  </v-dialog>
</template>

<script>
import { getAuth } from 'firebase/auth'

export default {
  name: 'AppHeader',
  data() {
    return {
      logoImage: require('../assets/logo.svg'),
      account: true,
      dataSelector: false,
    }
  },
  beforeMount() {
  },
  watch:{
  },
  methods: {
    hasAccount() {
      let linked = false
      try {
        const auth = getAuth()
        auth.currentUser.providerData.forEach(providers => {
          if (providers.providerId === 'google.com') {
            linked = true
          }
        })
      } catch(error) {
        linked = false
      }
      return linked
    },
    goToHome() {
      this.$router.push('/')
    },
    openDataSelector() {
      this.dataSelector = true
    },
    goToData(route) {
      this.dataSelector = false
      this.$router.push('/data/' + route)
    },
    goToProfile() {
      this.$router.push('/profile')
    },
  },
  computed: {
    onboarding() {
      return (this.$route.path.startsWith('/onboarding')
        || this.$route.path.startsWith('/login'))
    },
    forbidden() {
      return this.$route.path.startsWith('/forbidden')
    },
    data() {
      return this.$route.path.startsWith('/data')
    },
    plan() {
      return this.$route.path.startsWith('/plan')
    },
    admin() {
      return this.$route.path.startsWith('/admin')
    },
  },
}
</script>